const init = () => {

	const handleTabBtnClick = (e) => {

		const btn   = e.target
		const panel = document.getElementById(btn.getAttribute('aria-controls'))
		const parent = btn.closest('[data-tabs]')

		// Set all tab buttons as 'inactive'
		for (const el of parent.querySelectorAll('[role="tab"]')) {

			el.setAttribute('aria-selected', 'false')
			el.setAttribute('tabindex', '-1')
		}

		// Set all tab panels as 'inactive'
		for (const el of parent.querySelectorAll('[role="tabpanel"]')) {

			el.setAttribute('hidden', '')
		}

		// Set clicked button and panel as 'active'
		btn.setAttribute('aria-selected', 'true')
		btn.removeAttribute('tabindex')
		panel.removeAttribute('hidden')
	}
	
	for (const tabs of document.querySelectorAll('[data-tabs]')) {

		for (const btn of tabs.querySelectorAll('[role="tab"]')) {

			btn.addEventListener('click', handleTabBtnClick)
		}
	}
}

export default init